<template>
    <div class="dropzone-uploaded-file" v-if="uploadedFile">
        <div class="dropzone-uploaded-file__file-holder" v-if="isImage(uploadedFile)">
            <img :src="uploadedFile" alt="">
        </div>
        <div class="dropzone-file" v-else>
            <div class="dropzone-file__icon">
                <img src="/images/dropzone/file-blank.svg" alt="">
            </div>
        </div>

        <div class="dropzone-uploaded-file__hover-button">
            <button class="btn btn--secondary btn--uploaded-img-hover" @click.prevent="onRemove">{{ trans('buttons.remove') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        uploadedFile: String,
    },

    methods: {
        onRemove() {
            this.$emit('remove');
        },
        isImage(file) {
            let ext = file.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg'].includes(ext);
        }
    }
}
</script>
